import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 30px;
`

export const TableWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
  margin-top: 10px;

  table {
    min-width: 1000px;
  }

  .ant-pagination .ant-pagination-item-active {
    border-color: ${({ theme }) => theme.success};

    a {
      color: ${({ theme }) => theme.success};
    }
  }
`
